import { bookingDetailsToText } from './bookingInquiry';

/** Build Web3Forms message body from booking + form fields */
export function buildBookingMessage(formData, bookingLines = [], extraLines = {}) {
  const bookingBlock = bookingLines.length
    ? `Offer details:\n${bookingDetailsToText(bookingLines)}`
    : '';

  const skip = new Set(['botcheck', 'access_key', 'subject', 'message']);
  const formFields = [];
  formData.forEach((value, key) => {
    if (!skip.has(key) && value) {
      formFields.push(`${key}: ${value}`);
    }
  });

  const extra = Object.entries(extraLines)
    .filter(([, v]) => v != null && String(v).trim() !== '')
    .map(([k, v]) => `${k}: ${v}`)
    .join('\n');

  return [
    bookingBlock,
    extra,
    formFields.length ? `Customer form:\n${formFields.join('\n')}` : '',
  ]
    .filter(Boolean)
    .join('\n\n');
}
